import React from 'react';

let onDotClick = (sender, handler, index) => {
    handler(index);
}
let selected;

const SliderTabs = (props) => {
    let i = 0;
    return (<div className="sliderTabs clearfix">
        <ol>
            {props.tabs.filter(t => t.showTab && props.visible).map(t =>
                <li className="sliderTabItem"  key={i} data-selected={i === props.selected} onClick={(e) => props.onTabClick(getClickedIndex(e))} >
                    <span className="headerTabNumber" data-index={i}>{++i}</span>
                    {props.showText ? <span className={(i++ === props.selected) ? "tabHeader expandedTab" : "tabHeader mininizedTab"}>{" " + t.header}</span> : ""}                     
                </li>               
            )}
        </ol>
    </div>);
};
export default SliderTabs

let getClickedIndex = (sender) => {
    return sender.currentTarget.childNodes[0].dataset.index;

}

